
import React, { useState, useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import { MAIN_URL, APPLICATION_KEY } from "../../../Configurations/Urls";
import { getIndustry } from "../../../Apis/Organization-apis";
import {fetchOwnershipTypeCategory,} from "../../../Apis/OrganizationLocation";
import {
  MenuItem,
  TextField,
  CircularProgress,
  Autocomplete,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  Box,
  Typography,
} from "@mui/material";
import useAuthStore from "../../../Zustand/Store/useAuthStore";

function OrganizationData({ data }) {
  const [industries, setIndustries] = useState([]);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [generalCategories, setGeneralCategories] = useState([]);
  const [formData, setFormData] = useState();

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [Countrydata, setCountryData] = useState([]);
  const [applicationOptions, setApplicationOptions] = useState([]);

  useEffect(() => {
    setFormData(data);
  }, [data]);

  const { isLoggedIn, login, setAccess } = useAuthStore();
  const [formErrors, setFormErrors] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    {
      fetchOwnershipTypeCategory()
        .then((data) => {
          setGeneralCategories(data.businessownershiptypescategory);
        })
        .catch((err) => {
          setFormErrors(err.message);
        });
    }
  }, []);

  useEffect(() => {
    {
      getIndustry()
        .then((data) => {
          setIndustries(data.industries);
        })
        .catch((err) => {
          setFormErrors(err.message);
        });
    }
  }, []);


  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await axios.get(`${MAIN_URL}/api/general/countries/v1`);
        console.log("responres for countries ", res);
        setCountryData(res?.data?.data || []);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          toast.error("Session Expired!");
          window.location.href = "/login";
        }
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  // fetch state
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const res = await axios.get(
          `${MAIN_URL}/api/general/countries/${formData?.general_country_id}/states`
        );
        setStates(res?.data?.generalstates || []);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          toast.error("Session Expired!");
          window.location.href = "/login";
        }
        console.error("Error fetching states:", error);
      }
    };
    console.log("response for states ", states);
    if (formData?.general_country_id) {
      fetchStates();
    }
  }, [formData?.general_country_id]);

  // fetch cities
  useEffect(() => {
    const fetchCities = async () => {
      try {
        const res = await axios.get(
          `${MAIN_URL}/api/general/countries/${formData?.general_country_id}/states/${formData?.general_state_id}/cities`
        );

        console.log("responres for cities ", res);
        setCities(res?.data?.data || []);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          toast.error("Session Expired!");
          window.location.href = "/login";
        }
        console.error("Error fetching cities:", error);
      }
    };

    if (formData?.general_country_id && formData?.general_state_id) {
      fetchCities();
    }
  }, [formData?.general_country_id, formData?.general_state_id]);

  useEffect(() => {
    const loadApplicationOptions = async () => {
      if (!formData) {
        return;
      }

      try {
        const params = new URLSearchParams();
        if (formData.client_id) {
          params.set("client_id", formData.client_id);
        }
        const signupKey = formData.signup_application_key || APPLICATION_KEY;
        if (signupKey) {
          params.set("signup_application_key", signupKey);
        }

        const query = params.toString();
        const res = await axios.get(
          `${MAIN_URL}/api/organizations/signup/applications${
            query ? `?${query}` : ""
          }`
        );
        const apps = res?.data?.applications || [];
        setApplicationOptions(apps);

        setFormData((prev) => {
          if (!prev || (Array.isArray(prev.application_ids) && prev.application_ids.length > 0)) {
            return prev;
          }

          let defaultIds = [];
          const key = String(signupKey || "").toLowerCase();
          if (key) {
            const match = apps.find((app) =>
              String(app.application_name || "").toLowerCase().includes(key)
            );
            if (match) {
              defaultIds = [Number(match.application_id)];
            }
          }

          if (!defaultIds.length && apps.length === 1) {
            defaultIds = [Number(apps[0].application_id)];
          }

          return defaultIds.length
            ? { ...prev, application_ids: defaultIds }
            : prev;
        });
      } catch (error) {
        console.error("Error fetching signup applications:", error);
      }
    };

    loadApplicationOptions();
  }, [formData?.client_id, formData?.signup_application_key]);

  const handleApplicationToggle = (applicationId) => {
    const normalizedId = Number(applicationId);
    setFormData((prev) => {
      const currentIds = Array.isArray(prev?.application_ids)
        ? prev.application_ids.map(Number)
        : [];
      const nextIds = currentIds.includes(normalizedId)
        ? currentIds.filter((id) => id !== normalizedId)
        : [...currentIds, normalizedId];

      return {
        ...prev,
        application_ids: nextIds,
      };
    });
    setFormErrors((prev) => ({ ...prev, application_ids: "" }));
  };

  const isBusinessOrganizationType = (categoryId, categories = generalCategories) => {
    const selected = categories.find(
      (item) =>
        Number(item.general_business_ownership_type_category_id) ===
        Number(categoryId)
    );
    return (
      String(selected?.business_ownership_type_category_name || "")
        .trim()
        .toLowerCase() === "business"
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      let updatedData = {
        ...prev,
        [name]: value,
        ...(name === "general_country_id" && { general_state_id: "" }),
        ...(name === "general_state_id" && { general_city_id: "" }),
      };
      if (name === "general_business_ownership_type_category_id") {
        if (!isBusinessOrganizationType(value)) {
          updatedData.general_industry_id = "";
        }
      }
      return updatedData;
    });

    if (
      name === "general_business_ownership_type_category_id" &&
      !isBusinessOrganizationType(value)
    ) {
      setFormErrors((prev) => ({ ...prev, general_industry_id: "" }));
    }

    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.organization_name)
      errors.organization_name = "Organization Name is required";
    if (!formData.organization_short_name)
      errors.organization_short_name = "Short Name is required";
    if (!formData.general_country_id)
      errors.general_country_id = "Country is required";
    if (!formData.general_business_ownership_type_category_id)
      errors.general_business_ownership_type_category_id = "State is required";
    if (!Array.isArray(formData.application_ids) || formData.application_ids.length === 0) {
      errors.application_ids = "Select at least one application";
    }
    setFormErrors(errors);
    return Object.keys(errors)?.length === 0;
  };

  console.log("formdata", formData);

  const handleSubmit = async (e) => {
    try {
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session Expired!");
        window.location.href = "/login";
      }
    }
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    try {
      let res = await axios.post(`${MAIN_URL}/api/organizations`, {
        ...formData,
        general_industry_id: isBusinessOrganizationType(
          formData.general_business_ownership_type_category_id
        )
          ? formData.general_industry_id || null
          : null,
      });
      console.log("response", res);
      toast.success("Organization created successfully!");
      if (res?.data?.token) {
        const { token, user } = res.data;
        localStorage.setItem("token", token);
        setAccess(user?.role?.role?.system_role_name);
        login(user);
        navigate("/");
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session Expired!");
        window.location.href = "/login";
      }
      console.log("error", error);
      if (error?.response?.data?.errors !== undefined) {
        setFormErrors(error.response.data.errors);
      } else {
        toast.error("Failed to create Organization");
      }
    } finally {
      setLoading(false);
    }
  };

  const getSelectedOwnershipTypeName = () => {
    const selected = generalCategories.find(
      (item) =>
        item.general_business_ownership_type_category_id ===
        formData.general_business_ownership_type_category_id
    );
    return selected ? selected.business_ownership_type_category_name : "";
  };

  const compactFieldSx = {
    "& .MuiInputBase-root": { height: 36, fontSize: "0.85rem" },
    "& .MuiInputLabel-root": { fontSize: "0.85rem" },
    "& .MuiFormHelperText-root": { fontSize: "0.68rem", mt: 0, mb: 0 },
  };

  return (
    <form onSubmit={handleSubmit} className="organization-details-form">
      <div className="org-form-row">
        <TextField
          fullWidth
          size="small"
          label="Organization Name"
          name="organization_name"
          value={formData?.organization_name}
          onChange={handleChange}
          margin="dense"
          error={!!formErrors.organization_name}
          helperText={formErrors.organization_name}
          sx={compactFieldSx}
        />
      </div>
      <div className="org-form-row">
        <TextField
          fullWidth
          size="small"
          label="Organization Short Name"
          name="organization_short_name"
          value={formData?.organization_short_name}
          onChange={handleChange}
          margin="dense"
          error={!!formErrors.organization_short_name}
          helperText={formErrors.organization_short_name}
          sx={compactFieldSx}
        />
      </div>
      <div className="org-form-row">
        <TextField
          select
          fullWidth
          size="small"
          label="Organization Type"
          name="general_business_ownership_type_category_id"
          value={formData?.general_business_ownership_type_category_id}
          onChange={handleChange}
          margin="dense"
          error={!!formErrors.general_business_ownership_type_category_id}
          helperText={formErrors.general_business_ownership_type_category_id}
          sx={compactFieldSx}
        >
          {generalCategories.map((option) => (
            <MenuItem
              key={option?.general_business_ownership_type_category_id}
              value={option?.general_business_ownership_type_category_id}
            >
              {option.business_ownership_type_category_name}
            </MenuItem>
          ))}
        </TextField>
      </div>
      <div className="org-form-row">
        <TextField
          select
          fullWidth
          size="small"
          label="Industry"
          name="general_industry_id"
          value={
            isBusinessOrganizationType(
              formData?.general_business_ownership_type_category_id
            )
              ? formData?.general_industry_id
              : ""
          }
          onChange={handleChange}
          margin="dense"
          error={!!formErrors.general_industry_id}
          helperText={formErrors.general_industry_id}
          disabled={
            !formData?.general_business_ownership_type_category_id ||
            !isBusinessOrganizationType(
              formData?.general_business_ownership_type_category_id
            )
          }
          sx={compactFieldSx}
        >
          {industries.map((option) => (
            <MenuItem
              key={option.general_industry_id}
              value={option?.general_industry_id}
            >
              {option.industry_name}
            </MenuItem>
          ))}
        </TextField>
      </div>
      <div className="org-form-row">
        <Autocomplete
          sx={compactFieldSx}
          fullWidth
          size="small"
          options={Array.isArray(Countrydata) ? Countrydata : []}
          getOptionLabel={(option) => option.country_name || ""}
          value={
            Countrydata?.find(
              (c) => c.general_country_id === formData?.general_country_id
            ) || null
          }
          onChange={(e, newValue) => {
            handleChange({
              target: {
                name: "general_country_id",
                value: newValue ? newValue.general_country_id : "",
              },
            });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              margin="dense"
              label="Country"
              error={!!formErrors?.general_country_id}
              helperText={formErrors?.general_country_id}
            />
          )}
        />
      </div>
      <div className="org-form-row">
        <Autocomplete
          sx={compactFieldSx}
          fullWidth
          size="small"
          options={Array.isArray(states) ? states : []}
          getOptionLabel={(option) => option.state_name || ""}
          value={
            states?.find(
              (s) => s.general_state_id === formData?.general_state_id
            ) || null
          }
          onChange={(e, newValue) => {
            handleChange({
              target: {
                name: "general_state_id",
                value: newValue ? newValue.general_state_id : "",
              },
            });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              margin="dense"
              label="State"
              error={!!formErrors?.general_state_id}
              helperText={formErrors?.general_state_id}
            />
          )}
        />
      </div>
      <div className="org-form-row">
        <Autocomplete
          sx={compactFieldSx}
          fullWidth
          size="small"
          options={Array.isArray(cities) ? cities : []}
          getOptionLabel={(option) => option.city_name || ""}
          value={
            cities?.find(
              (c) => c.general_city_id === formData?.general_city_id
            ) || null
          }
          onChange={(e, newValue) => {
            handleChange({
              target: {
                name: "general_city_id",
                value: newValue ? newValue.general_city_id : "",
              },
            });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              margin="dense"
              label="City"
              error={!!formErrors?.general_city_id}
              helperText={formErrors?.general_city_id}
            />
          )}
        />
      </div>

      {applicationOptions.length > 0 ? (
        <Box className="org-form-applications">
          <Typography sx={{ fontSize: "0.8rem", mb: 0 }}>
            Applications for this organization
          </Typography>
          <FormGroup sx={{ flexDirection: "row", flexWrap: "wrap", gap: 0, py: 0 }}>
            {applicationOptions.map((option) => (
              <FormControlLabel
                key={option.application_id}
                sx={{ mr: 1, my: 0, "& .MuiFormControlLabel-label": { fontSize: "0.8rem" } }}
                control={
                  <Checkbox
                    size="small"
                    sx={{ py: 0.25 }}
                    checked={(formData?.application_ids || [])
                      .map(Number)
                      .includes(Number(option.application_id))}
                    onChange={() => handleApplicationToggle(option.application_id)}
                    disabled
                  />
                }
                label={option.application_name || `Application #${option.application_id}`}
              />
            ))}
          </FormGroup>
          {!!formErrors.application_ids && (
            <FormHelperText error sx={{ mt: 0 }}>
              {formErrors.application_ids}
            </FormHelperText>
          )}
        </Box>
      ) : null}

      <input
        type="submit"
        className="btn btn-primary w-100"
        value={loading ? "Submitting..." : "Add Organization"}
        disabled={loading}
      />
    </form>
  );
}

export default OrganizationData;
